import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import Vuelidate from "vuelidate";
import { validationMixin } from "vuelidate";
import "./utils/string";

Vue.config.productionTip = false

Vue.use(Vuelidate);


Vue.mixin(validationMixin);

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
